// The environment this build of the console operates on, as resolved and
// injected by vite.config.ts (import.meta.env.VITE_ADMIN_ENV). Re-validated
// here rather than trusted: a typo in the config would otherwise become a
// wrong label on a console that moves real money.
import { parseAdminEnv } from './adminEnvs';

export { parseAdminEnv, type AdminEnv } from './adminEnvs';

export const ADMIN_ENV = parseAdminEnv(import.meta.env.VITE_ADMIN_ENV);
